var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2527_3322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2527_3322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75577 16.5833C6.386 16.5833 6.07027 16.4525 5.80858 16.1907C5.54687 15.929 5.41602 15.6133 5.41602 15.2436V5.49999H4.95768C4.80395 5.49999 4.67524 5.44857 4.57156 5.34572C4.46786 5.24289 4.41602 5.11522 4.41602 4.96272C4.41602 4.81024 4.46786 4.68111 4.57156 4.57535C4.67524 4.46957 4.80395 4.41668 4.95768 4.41668H7.99933V4.16668C7.99933 3.98624 8.06319 3.83215 8.19091 3.70443C8.31863 3.57671 8.47272 3.51285 8.65316 3.51285H11.3455C11.5259 3.51285 11.68 3.57671 11.8077 3.70443C11.9355 3.83215 11.9993 3.98624 11.9993 4.16668V4.41668H15.041C15.1947 4.41668 15.3234 4.4681 15.4271 4.57095C15.5308 4.6738 15.5826 4.80147 15.5826 4.95395C15.5826 5.10645 15.5308 5.23558 15.4271 5.34135C15.3234 5.44711 15.1947 5.49999 15.041 5.49999H14.5826V15.2345C14.5826 15.6145 14.4518 15.9343 14.1901 16.1939C13.9284 16.4535 13.6127 16.5833 13.2429 16.5833H6.75577ZM13.4993 5.49999H6.49933V15.2436C6.49933 15.3183 6.52337 15.3798 6.57145 15.4279C6.61954 15.476 6.68097 15.5 6.75577 15.5H13.2429C13.3177 15.5 13.3791 15.476 13.4272 15.4279C13.4753 15.3798 13.4993 15.3183 13.4993 15.2436V5.49999ZM8.33589 14H9.4192V6.99999H8.33589V14ZM10.5795 14H11.6628V6.99999H10.5795V14Z",
    fill: "#5E6A7D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.936d3b696d1b3f22ff1397bff40b3d6e.svg";
export { ForwardRef as ReactComponent };